module.exports = __webpack_public_path__ + "static/media/share-48.b898a1fa.svg";